'use client'

import { type HTMLAttributes, useEffect, useState, forwardRef } from 'react'
import { twMerge } from 'tailwind-merge'
import { calculateTimeLeft } from './utils/calculateTimeLeft'
import { padTime } from './utils/padTime'

export interface CountdownTimerProps extends HTMLAttributes<HTMLSpanElement> {
  endTime: Date
}

export const CountdownTimer = forwardRef<HTMLSpanElement, CountdownTimerProps>(
  ({ endTime, ...props }, ref) => {
    const [timeLeft, setTimeLeft] = useState(() => calculateTimeLeft(endTime))

    useEffect(() => {
      const timer = setInterval(() => {
        setTimeLeft(calculateTimeLeft(endTime))
      }, 1000)

      return () => {
        clearInterval(timer)
      }
    }, [endTime])

    return (
      <span className={twMerge('tabular-nums', props.className)} ref={ref} {...props}>
        {padTime(timeLeft.hours)}:{padTime(timeLeft.minutes)}:{padTime(timeLeft.seconds)}
      </span>
    )
  }
)

CountdownTimer.displayName = 'CountdownTimer'
